import { useEffect, useMemo } from 'react'
import { useFeatureFlags } from 'components/hooks/useFeatureFlags'

const useCookiePolicyHelpers = (oneTrustAccessKey: string) => {
  const { getFlag } = useFeatureFlags()
  const releaseCookieConsentBannerTemp = useMemo(
    () => getFlag('releaseCookieConsentBannerTemp') as boolean,
    [getFlag],
  )

  useEffect(() => {
    if (!oneTrustAccessKey || !releaseCookieConsentBannerTemp) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'ot-clear-dup-categories'

    script.innerHTML = `
      // SHOULD BE USED ONLY ON COOKIE POLICY. TRIGGER FUNCTION BELOW TO REMOVE DUPLICATE CATEGORIES
      function clearDup() {
        var sec = document.getElementById("ot-sdk-cookie-policy");
        if (!sec) return;

        var children = sec.children;
        var tally = {};
        
        for (var i = children.length - 1; i >= 0; i--) {
          var heading = children[i].firstChild?.innerText;
          if (!heading) continue;

          if (tally[heading] === undefined) {
            tally[heading] = 1;
          } else {
            children[i].remove();
          }
        }
      }
    `

    document.head.appendChild(script)

    return () => {
      const existing = document.getElementById('ot-clear-dup-categories')
      if (existing) existing.remove()
    }
  }, [oneTrustAccessKey, releaseCookieConsentBannerTemp])
}

export default useCookiePolicyHelpers
